import { createFileRoute } from '@tanstack/react-router';
import PublicTemplateBrowserPage from '@/pages/(protected)/workspaces/[workspaceId]/templates/public-browser';

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/templates/public')({
  component: PublicTemplateBrowserPage,
});
